import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const About = () => {
  return (
    <section className="py-32 px-4 relative bg-[#030014]">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-24 items-center">
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        >
          <h2 className="text-5xl md:text-6xl font-extrabold mb-8 leading-tight">
            The Digital Bridge to <span className="text-gradient">Enlightenment.</span>
          </h2>
          <p className="text-slate-400 text-xl leading-relaxed mb-10 font-light italic">
            "DaiKhoToken isn't just a currency; It's a transformative asset eco-system. Born from the principles of Usui Reiki utilizing the Dai Kho Myo mantra of <span className="text-white font-bold">"I am the Master of my Energy"</span>, we merge modern DeFi mechanics with real-world wellness services and merchandise."
          </p>

          <div className="space-y-8">
            <div className="flex gap-6 group">
              <div className="mt-1 w-12 h-12 rounded-xl bg-purple-500/10 flex items-center justify-center shrink-0 border border-purple-500/20 group-hover:bg-purple-500/30 transition-all">
                <SafeIcon name="Lock" className="text-purple-400 w-5 h-5" />
              </div>
              <div>
                <h4 className="text-xl font-bold text-white mb-1 uppercase tracking-tighter">Fixed Supply</h4>
                <p className="text-slate-500 leading-relaxed font-light">No mint function. Scarcity is built into our DNA.</p>
              </div>
            </div>

            <div className="flex gap-6 group">
              <div className="mt-1 w-12 h-12 rounded-xl bg-cyan-500/10 flex items-center justify-center shrink-0 border border-cyan-500/20 group-hover:bg-cyan-500/30 transition-all">
                <SafeIcon name="Zap" className="text-cyan-400 w-5 h-5" />
              </div>
              <div>
                <h4 className="text-xl font-bold text-white mb-1 uppercase tracking-tighter">Staking Rewards</h4>
                <p className="text-slate-500 leading-relaxed font-light">Earn DKT by securing the ecosystem through time-locked vaults on Blastpad.</p>
              </div>
            </div>

            <div className="flex gap-6 group">
              <div className="mt-1 w-12 h-12 rounded-xl bg-pink-500/10 flex items-center justify-center shrink-0 border border-pink-500/20 group-hover:bg-pink-500/30 transition-all">
                <SafeIcon name="ShoppingBag" className="text-pink-400 w-5 h-5" />
              </div>
              <div>
                <h4 className="text-xl font-bold text-white mb-2 uppercase tracking-tighter">Real Utility & Rewards</h4>
                <div className="space-y-4">
                  <p className="text-slate-400 bg-white/5 border border-white/10 p-4 rounded-2xl font-medium">
                    Redeem DKT rewards for Reiki Services and/or Exclusive Merch Purchases
                  </p>
                  <div className="grid sm:grid-cols-2 gap-4">
                    <div className="p-4 bg-purple-500/5 rounded-2xl border border-purple-500/20">
                      <p className="text-[10px] font-bold text-purple-400 uppercase tracking-widest mb-1">Reiki Crypto Rewards</p>
                      <p className="text-white text-sm font-bold">777 / 1,777 / 2,777 DKT</p>
                    </div>
                    <div className="p-4 bg-pink-500/5 rounded-2xl border border-pink-500/20">
                      <p className="text-[10px] font-bold text-pink-400 uppercase tracking-widest mb-1">Merch Rewards (Shirts/Caps/Hoodies)</p>
                      <p className="text-white text-sm font-bold">277 / 333 / 369 DKT</p>
                    </div>
                  </div>
                  <p className="text-[10px] text-red-400 font-bold uppercase tracking-[0.2em]">
                    Limited Rewards (ONLY 154,444,444 DKT available for rewards)
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.5, ease: [0.16, 1, 0.3, 1] }}
          className="relative flex items-center justify-center"
        >
          <div className="relative w-[500px] h-[500px]">
            <div className="absolute inset-0 bg-purple-600/20 rounded-full blur-[100px] animate-pulse" />
            <div className="absolute inset-0 border border-white/5 rounded-full animate-[spin_20s_linear_infinite]" />
            <div className="absolute inset-10 border border-purple-500/20 rounded-full animate-[spin_15s_linear_infinite_reverse]" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 bg-[#0a0515] rounded-full flex items-center justify-center border-2 border-purple-500/50 shadow-[0_0_80px_rgba(168,85,247,0.3)] neon-glow-purple overflow-hidden">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/53257d18d934c13deb15172e6d977d0c36a3dd097c5c5cf609cb857dac040a3963b23aa6d7b2ab716a4b1aba01045119/images/aW1hZ2UvcG5n/86073368fa597368b31df5a13528b417.png" 
                alt="DaiKhoToken Logo" 
                className="w-full h-full object-contain scale-[1.65] invert drop-shadow-[0_0_15px_rgba(255,255,255,0.2)]"
              />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;